import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface StandardBlockProps {
  title: string;
  detail: string;
  icon: IconProp;
}

const StandardBlock = ({ title, detail, icon }: StandardBlockProps) => {
  return (
    <div className="self-stretch h-28 bg-white rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.00)] outline outline-1 -outline-offset-1 outline-neutral-200 inline-flex flex-col items-start gap-2 overflow-hidden">
      <div className="self-stretch h-28 px-5 py-4 rounded-lg flex flex-col justify-between items-start">
        <div className="self-stretch inline-flex items-center justify-between gap-1">
          <div className="flex-1 text-teritary text-sm font-semibold font-['Inter'] leading-tight">
            {title}
          </div>
          <div className="w-5 h-5 flex items-center justify-center">
            <Icon icon={icon} className="text-sky-600" />
          </div>
        </div>
        <div className="text-primary text-4xl font-extrabold font-['Inter'] leading-10">
          {detail}
        </div>
      </div>
    </div>
  );
};

export default StandardBlock;
